import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE_URL = `${u}/note`;

export const getAllNotes = async () => {
  const res = await apiFetch(BASE_URL);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const getSharedNotes = async () => {
  const res = await apiFetch(`${BASE_URL}/shared`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const createNote = async (data) => {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(data),
  });
  return res.json();
};

export const getNoteById = async (id) => {
  const res = await apiFetch(`${BASE_URL}/${id}`);
  if (!res.ok) return null;
  return res.json();
};

export const updateNote = async (id, data) => {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteNote = async (id) => {
  return apiFetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
  });
};

export const emailNote = async (id) => {
  return apiFetch(`${BASE_URL}/${id}/email`, {
    method: "POST",
  });
};

export const emailNoteToRecipients = async (id, payload) => {
  return apiFetch(`${BASE_URL}/${id}/email`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
};

export const shareNote = async (id, payload) => {
  return apiFetch(`${BASE_URL}/${id}/share`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
};
